module.exports = __webpack_public_path__ + "overview-d35a4493/upsell_icon_purple-14f1b6afba9e6d2777bc298fecc1b561.png";